<script>
import ImaginaryUpgradeButton from "./ImaginaryUpgradeButton";

export default {
  name: "ImaginaryUpgradesTab",
  components: {
    ImaginaryUpgradeButton
  },
  data() {
    return {
      baseRMCap: new Decimal(),
      capRM: new Decimal(),
      scaleTime: 0,
      capStr: "",
    };
  },
  computed: {
    upgrades: () => ImaginaryUpgrades.all,
    lockTooltip: () => `Фиксатор требований предотвращает только ручные и автоматизированные действия. Все связанные
      улучшения не будут отключены и всё ещё могут привести к провалу требования.`,
  },
  methods: {
    update() {
      this.baseRMCap.copyFrom(MachineHandler.baseRMCap);
      this.capRM.copyFrom(MachineHandler.hardcapRM);
      this.scaleTime = MachineHandler.scaleTimeForIM;
      this.capStr = formatMachines(MachineHandler.hardcapRM, MachineHandler.currentIMCap);
    },
    id(row, column) {
      return (row - 1) * 5 + column - 1;
    }
  }
};
</script>

<template>
  <div class="l-reality-upgrade-grid">
    <div class="c-cap-text">
      Ваше ограничение машин равно <span class="c-reality-tab__reality-machines">{{ capStr }}</span>.
    </div>
    <div class="c-info-text">
      Вы достигли лимита Реальности и не можете иметь более чем {{ format(capRM) }} Машин Реальности.
      <br>
      Машины, полученные сверх {{ format(baseRMCap) }} повысят максимальное количество Мнимых Машин, которые вы можете
      иметь.
      <br>
      Мнимые Машины зарабытваются пассивно со временем до ограничения, но с приближением к ограничению заработок
      экспоненциально замедляется.
      <br>
      Каждые {{ formatInt(scaleTime) }} секунд разница в текущем значении ММ и значении ограничения сократится в два
      раза.
      <br>
      <br>
      Первые два ряда улучшений могут быть куплены бесконечное количество раз, а оставшиеся улучшения одноразовые и
      требуют выполнения определенных условий для разблокировки.
      <br>
      Улучшения здесь имеют тот же геймплей и такое же поведение как у Улучшений Реальности, но покупаются за
      Мнимые Машины.
      <span :ach-tooltip="lockTooltip">
        <i class="fas fa-question-circle" />
      </span>
    </div>
    <div
      v-for="row in 5"
      :key="row"
      class="l-reality-upgrade-grid__row"
    >
      <ImaginaryUpgradeButton
        v-for="column in 5"
        :key="id(row, column)"
        :upgrade="upgrades[id(row, column)]"
      />
    </div>
  </div>
</template>

<style scoped>
.c-cap-text {
  color: var(--color-text);
  font-size: 1.5rem;
}

.c-info-text {
  color: var(--color-text);
  margin: 1.5rem;
}
</style>
